/**
 * VowPath 品牌 - Home 页面配置
 */
import { homeCommonConfig } from './common'
import type { HomePageConfig } from './types'

/**
 * VowPath 品牌主题配置
 */
export const theme = {
  // 首页背景图（深色主题不再使用亮色背景图）
  homeBg: '',
  // 标签模块背景图
  tagsBg: '',

  // 标签按钮选中状态（深紫 + 粉描边，对照蓝湖）
  tagActiveBg: '#4E2A5A',
  tagActiveText: '#FFFFFF',
  tagActiveBorder: '#FF5ACE',

  // 标签按钮未选中状态
  tagInactiveBg: '#2B2C54',
  tagInactiveText: '#DBDAE8',
  tagInactiveBorder: '#424366',

  // Tab 激活状态渐变底部装饰线
  tabActiveGradient: 'linear-gradient(270deg, rgba(255,90,205,1) 0%, rgba(154,87,255,1) 100%)',
  // Tab 激活状态文字和下划线颜色
  tabActiveColor: 'linear-gradient(270deg, rgba(255,107,210,1) 0%, rgba(161,98,255,1) 100%)',
  // sticky-header 背景
  stickyHeaderBg: '#20214B',
} as const

export const homeConfig: HomePageConfig = {
  theme,
  texts: homeCommonConfig.texts,
}
